import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import './AppFooter.css';
import ReactGA from 'react-ga';

class AppFooter extends Component {

	fireGoogleAnalyticsEvent(category, action, label) {
		ReactGA.event({
			category: category,
			action: action,
			label: label
		});
	}

	render() {
        return (
			<footer className="AppFooter container">
				<div className="AppFooter-links"><Link to="/impressum/">Impressum</Link></div>
				<div className="AppFooter-info">Alle Angaben ohne Gewähr</div>
				<div className="AppFooter-social">Share on
					<a target="_blank" href={'https://www.facebook.com/sharer.php?u=' + document.URL} title="Share on Facebook" onClick={()=>this.fireGoogleAnalyticsEvent('Social', 'Facebook', document.URL)}>
						<img src="/icons/facebook.svg" alt="Auf Facebook teilen" />
					</a>
					<a target="_blank" href={'https://twitter.com/intent/tweet?url=' + document.URL} title="Share on Twitter" onClick={()=>this.fireGoogleAnalyticsEvent('Social', 'Twitter', document.URL)}>
						<img src="/icons/twitter.svg" alt="Auf Twitter teilen" />
					</a>
				</div>
			</footer>
        );
    }
}

export default AppFooter;



// WEBPACK FOOTER //
// ./src/components/AppFooter.js